import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  show() {
    this.overlayTarget.classList.remove("hidden")

    // Disable form inputs to prevent changes during submission
    const form = this.element
    const inputs = form.querySelectorAll("input, select, textarea, button")
    inputs.forEach(input => {
      input.disabled = true
    })
  }

  hide() {
    this.overlayTarget.classList.add("hidden")

    // Re-enable form inputs (in case of Turbo error/validation failure)
    const form = this.element
    const inputs = form.querySelectorAll("input, select, textarea, button")
    inputs.forEach(input => {
      input.disabled = false
    })
  }

  // Turbo calls this before form submission
  submit(event) {
    this.show()
  }

  // Called if Turbo frame/stream fails
  connect() {
    // Listen for turbo events to hide overlay on success/error
    document.addEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  disconnect() {
    document.removeEventListener("turbo:submit-end", this.handleSubmitEnd.bind(this))
  }

  handleSubmitEnd(event) {
    // If the form submission completes (success or error), hide overlay
    // The success case will navigate away, but the error case needs to hide it
    if (!event.detail.success) {
      this.hide()
    }
  }
}
